import React, { useEffect, useState } from "react";
import MongoDBChart from "./MongoDBChart";
import { getAuthData, isUserOnline } from "../../../services/storage/LocalStorage";
import config from "../../../utils/config/config";


const FMChart = ({ message, section }) => {
	const formattedMessage = Array.isArray(message) && message.length ? message[0] : message

	const source =
		formattedMessage?.options ??
		(formattedMessage?.dashboardId ? formattedMessage : {})

	const { dashboardId, userDomain, filter, preFilter, visualisation } = source
	const { height = null } = section || {};
	const [data, setData] = useState({});
	const { auth } = getAuthData();

	let baseURL = config?.gRPCURL;

	useEffect(() => {
		const url = `${baseURL}/grpc/user.UserService/GetMongoDashboardData`;
		if (!isUserOnline()) return;

		fetch(url, {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
				sessionId: auth?.sessionId,
			},
			body: JSON.stringify({
				dashboardId,
				userDomain,
				tokenPayload: JSON.stringify({ userDomain }),
				visualisation,
			}),
		})
			.then((response) => {
				if (!response.ok) {
					throw new Error(`HTTP error! status: ${response.status}`);
				}
				return response.json();
			})
			.then((myJson) => {
				if (!myJson.success) {
					// API returned a failure (business error)
					throw new Error(myJson.error || "Unknown API error");
				}

				setData(myJson);
			})
			.catch((error) => {
				console.error("Fetch/API error:", error.message);
				setData({ error: true, message: error.message });
			});

	}, [auth?.sessionId]);

	const isDashboard = !source?.visualisation;
	return (
		<div
			className={`flex justify-center items-center flex-col ${isDashboard ? "iframe-parent" : ''}`}
			style={{
				height: height ? `${height}px` : '180px'
			}}
		>
			{data && Object.entries(data).length > 0 && (
				<MongoDBChart
					resourceId={data?.mongoDashboardId}
					isDashboard={isDashboard}
					baseUri={data?.mongoDashboardUrl}
					token={data?.token}
					filter={filter}
					preFilter={preFilter}
				/>
			)}
		</div>
	);
};

export default FMChart;
